import { ReactNode, useEffect, useState } from "react";
import styled from "styled-components";
import { RowView2 } from "../style/common_style";
import Admin_menubar from "./Admin_menubar";
import "./adminTheme.css";
import api from "../axios_Interceptor/api";
import url from "../server";

const Container = styled(RowView2)`
  width: 100%;
  height: var(--browser-layout-height, 100vh);
  font-family: var(--font-family-base), sans-serif; font-weight: var(--font-weight-regular);
  font-size: var(--text-body);
  line-height: 1.5;
  color: var(--admin-ink);
  background-color: var(--admin-canvas);
  :where(button, input, select, textarea):not([class]) { font-family: inherit; }
  button:focus-visible, input:focus-visible, select:focus-visible, textarea:focus-visible,
  a:focus-visible { outline: 2px solid var(--admin-theme-focus, var(--admin-accent)); outline-offset: 2px; }
  input[type="checkbox"], input[type="radio"] { accent-color: var(--admin-accent); }
`;
const ConBox = styled.div<{ $inquiry: boolean; $compactTop: boolean; $fixedContent: boolean }>`  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: ${({ $inquiry, $fixedContent }) => $inquiry || $fixedContent ? "hidden" : "auto"};  div.children {
    flex: 1;
    min-height: 0;
    padding: ${({ $inquiry }) => $inquiry ? "0" : "1.5rem"};
    border-top: 1px solid var(--admin-border);
    background-color: ${({ $inquiry }) => $inquiry ? "var(--admin-surface)" : "var(--admin-canvas)"};
    overflow: ${({ $inquiry, $fixedContent }) => $inquiry || $fixedContent ? "hidden" : "auto"};    ${({ $fixedContent }) => $fixedContent && 'display: flex; flex-direction: column;'}    padding-top: ${({ $inquiry, $compactTop }) => $inquiry || $compactTop ? "0" : "30px"};
  }
`;
interface Layout {
  children: ReactNode;
  menuname: string;
  collapsibleSidebar?: boolean;
  coinRefreshVersion?: number;
  compactTop?: boolean;
  fixedContent?: boolean;}

const Layout_Admin = (props: Layout) => {
  const { children } = props;
  const menuname = props.menuname;
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    try { return localStorage.getItem('fanbird.admin.sidebar.open') !== 'false'; }
    catch { return true; }
  });
  const toggleSidebar = () => {
    const next = !sidebarOpen;
    setSidebarOpen(next);
    try { localStorage.setItem('fanbird.admin.sidebar.open', String(next)); }
    catch { /* The toggle still works when browser storage is unavailable. */ }
  };
  const [hasExcessOrder, setHasExcessOrder] = useState(false);

  useEffect(() => {
    api
      .get(url.Communication_url.oversell_notification)
      .then((res) => {
        if (res.data && Array.isArray(res.data) && res.data.length > 0) {
          setHasExcessOrder(true);
        } else {
          setHasExcessOrder(false);
        }
      })
      .catch(() => setHasExcessOrder(false));
  }, []);

  const sidebarToggle = (<SidebarToggle type="button" aria-controls="live-detail-sidebar" aria-expanded={sidebarOpen}
          aria-label={sidebarOpen ? '사이드바 닫기' : '사이드바 열기'} title={sidebarOpen ? '사이드바 닫기' : '사이드바 열기'}
          onClick={toggleSidebar}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            <rect x="3" y="4" width="18" height="16" rx="2" /><path d="M9 4v16" />
          </svg>
          {sidebarOpen && <span>사이드바 닫기</span>}
        </SidebarToggle>);

  return (
    <Container className="top admin-layout">
      {props.collapsibleSidebar ? <Sidebar $open={sidebarOpen}>
        <SidebarBody id="live-detail-sidebar">
          <Admin_menubar menuname={menuname} hasExcessOrder={hasExcessOrder} collapsed={!sidebarOpen} sidebarToggle={sidebarToggle} coinRefreshVersion={props.coinRefreshVersion} />
        </SidebarBody>
      </Sidebar> : <Admin_menubar menuname={menuname} hasExcessOrder={hasExcessOrder} />}

      <ConBox $inquiry={menuname === "1:1문의"} $compactTop={Boolean(props.compactTop)} $fixedContent={Boolean(props.fixedContent)}>        <div className="children">
          {children}
        </div>
      </ConBox>
    </Container>
  );
};

export default Layout_Admin;

const Sidebar = styled.aside<{ $open: boolean }>`
  display: flex; flex-direction: column; height: 100%; min-height: 0; flex-shrink: 0;
  width: ${props => props.$open ? 'var(--sidebar-width)' : '4.75rem'};
  background: var(--color-bg-sidebar);
  @media (max-width: 900px) { width: ${props => props.$open ? '4.75rem' : '4.75rem'}; }
`;
const SidebarBody = styled.div`display: flex; flex: 1; min-height: 0; &[hidden] { display: none; }`;
const SidebarToggle = styled.button`
  box-sizing: border-box; display: flex; align-items: center; justify-content: center; gap: var(--space-2);
  flex-shrink: 0; width: 100%; min-height: var(--touch-target); margin: 0 0 var(--space-3); padding: 0 var(--space-2);
  border: 1px solid var(--color-sidebar-border); border-radius: var(--radius-md);
  background: transparent; color: var(--color-sidebar-text-active); font: inherit; cursor: pointer;
  svg { flex-shrink: 0; }
  &:hover { background: var(--color-sidebar-item-active-bg); }
  @media (max-width: 900px) { span { display: none; } }
`;
